import constants from 'common/helpers/constants'


export const initialState = {
  paymentMethod: constants.paymentMethods.creditCard,
  isShippingFormValid: false,
  inquire: {
    isFetching: true,
    data: {
      coupon: {
        code: null,
        isFetching: false,
      },
      subscription: {
        price: 1495,
        shipping: null,
        discount: null,
      },
      bill: {
        tax: null,
        price: null,
        shipping: null,
        discount: null,
        upchargePrice: null,
      },
      subscriptionCasePrice: null,
    },
  },
  bill: {
    items: [],
    total: 1495,
  },
  outOfStockProducts: [],
}

export const setPaymentMethod = (state, paymentMethod) => ({ ...state, paymentMethod })

export const setIsShippingValid = (state, isValid) => ({ ...state, isShippingFormValid: isValid })

export const setInquireFetchingStatus = (state, isFetching) => ({
  ...state,
  inquire: {
    ...state.inquire,
    isFetching,
    error: null,
  },
})

export const setInquireAndBillData = (state, { bill, inquireData }) => ({
  ...state,
  inquire: {
    isFetching: false,
    error: null,
    data: inquireData,
  },
  bill,
})

export const setOutOfStockProducts = (state, outOfStockProducts) => ({
  ...state,
  outOfStockProducts,
})

export const removeBillItems = (state, payload) => ({
  ...state,
  bill: {
    ...state.bill,
    items: [],
  },
})

export const update = (state, newState) => newState
